var map = {
	"./DataDeletion": [
		1716,
		716
	],
	"./DataDeletion/": [
		1716,
		716
	],
	"./DataDeletion/index": [
		1716,
		716
	],
	"./DataDeletion/index.tsx": [
		1716,
		716
	],
	"./Home": [
		5749,
		749
	],
	"./Home/": [
		5749,
		749
	],
	"./Home/index": [
		5749,
		749
	],
	"./Home/index.tsx": [
		5749,
		749
	],
	"./Privacy": [
		9062,
		62
	],
	"./Privacy/": [
		9062,
		62
	],
	"./Privacy/index": [
		9062,
		62
	],
	"./Privacy/index.tsx": [
		9062,
		62
	],
	"./Security": [
		5696,
		696
	],
	"./Security/": [
		5696,
		696
	],
	"./Security/index": [
		5696,
		696
	],
	"./Security/index.tsx": [
		5696,
		696
	],
	"./Terms": [
		59,
		59
	],
	"./Terms/": [
		59,
		59
	],
	"./Terms/index": [
		59,
		59
	],
	"./Terms/index.tsx": [
		59,
		59
	],
	"./legal/styles": [
		4981,
		981
	],
	"./legal/styles.ts": [
		4981,
		981
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629;
module.exports = webpackAsyncContext;